var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"unload"},[_c('r-main-panel',[_c('unload-right-panel')],1),_c('unload-content')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }